<div class="icon-text-date-cell">
  <div class="icon-text-date-cell-container">
    <div class="icon-text-date-cell-text">
      <p class="icon-text-date-cell-text-grey-bold-16px limit-title-line"
        [matTooltip]="title || ''"
        [matTooltipDisabled]="!title"
        matTooltipClass="custom-tooltip"
        matTooltipPosition="above"
      >
        {{ title }}
      </p>
      <div *ngIf="type === 'Event'">
        <app-smart-link [route]="editRoute" (onSmartClick)="actionEdit()">
          <p class="icon-text-date-cell-click-edit">
            Editar
          </p>
        </app-smart-link>
      </div>
      <div *ngIf="type === 'News'" class="card-occasion-options">
        <app-card-occasion-options
          #actionSelect
          [editRoute]="editRoute"
          [detailsRoute]="detailsRoute"
          (selected)="handleSelectedOption($event)"
        ></app-card-occasion-options>
      </div>
    </div>
    <p
      class="icon-text-date-cell-text-grey-bold-14px max-lines"
      [innerHTML]="description | sanitizeHtml"
    ></p>
    <div class="flex-div">
      <div *ngIf="dateStr && hourRangeStr">
        <p class="date-title">Data início</p>
        <div class="icon-text-date-cell-date-container">
          <div class="icon-text-date-cell-month-container">
            <img
              class="icon-text-date-cell-month-icon"
              src="../assets/icons/calendar-18px.svg"
            />
            <p class="icon-text-date-cell-text-grey-regular-12px">
              {{ dateStr }}
            </p>
          </div>
          <div class="icon-text-date-cell-day-container">
            <img
              class="icon-text-date-cell-day-icon"
              src="../assets/icons/watches-18px.svg"
            />
            <p class="icon-text-date-cell-text-grey-regular-12px">
              {{ hourRangeStr }}
            </p>
          </div>
        </div>
      </div>

      <div *ngIf="dateEnd && hourRangeEndStr">
        <p class="date-title">Data fim</p>
        <div class="icon-text-date-cell-date-container">
          <div class="icon-text-date-cell-month-container">
            <img
              class="icon-text-date-cell-month-icon"
              src="../assets/icons/calendar-18px.svg"
            />
            <p class="icon-text-date-cell-text-grey-regular-12px">
              {{ dateEnd }}
            </p>
          </div>
          <div class="icon-text-date-cell-day-container">
            <img
              class="icon-text-date-cell-day-icon"
              src="../assets/icons/watches-18px.svg"
            />
            <p class="icon-text-date-cell-text-grey-regular-12px">
              {{ hourRangeEndStr }}
            </p>
          </div>
        </div>
      </div>
      <div *ngIf="scheduled" class="chip">Programada</div>
    </div>
  </div>
</div>
